import { ORDER_TYPE } from "util/constants";

export function getBusiness(state) {
  return state.business.business;
}

export function getDeliverySchedule(state) {
  const business = getBusiness(state);
  return business?.services?.[ORDER_TYPE.DELIVERY]?.hours;
}

export function getGeneralSchedule(state) {
  const business = getBusiness(state);
  return business?.settings?.generalOperatingHours;
}

export function getTimeZone(business) {
  return business?.settings?.hasOwnProperty("timeZone")
    ? business.settings.timeZone
    : "Asia/Dubai";
}

export function selectCountryCode(state) {
  const business = getBusiness(state);
  return business?.settings?.countryCode ?? "+9715";
}

export function selectDefaultBookingDuration(state) {
  const business = getBusiness(state);
  return business?.settings?.durationOfBooking ?? 60;
}
